module.exports = global.config = {
    host: "https://ckan.sampangkab.go.id",
    //subdomain: "satudata",
  };